module.exports = __webpack_public_path__ + "static/media/app-store-button.7c81fc8e.svg";